<div class="product-container">
  <div *ngIf="coverUrl" class="logo-product">
    <img width="50" [src]="coverUrl ? coverUrl : ''" alt="" />
  </div>

  <nb-card>
    <nb-card-header>
      <h4 class="product-title">
        {{ product.title.charAt(0).toUpperCase() + product.title.slice(1) }}
      </h4>
    </nb-card-header>

    <nb-card-footer>
      <h2 class="product-price">{{ product.price | number: 0 }} đ</h2>
    </nb-card-footer>
  </nb-card>
</div>
